import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const StarEmptyIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 11 11"
    >
      <path
        d="M10.7064 3.87305C10.6053 3.56225 10.3421 3.33495 10.0203 3.2803L7.39144 2.8306L6.15119 0.4695L6.15169 0.46925C5.99934 0.1797 5.70199 0 5.37484 0H5.37434C5.04744 0.00025 4.75009 0.1802 4.59824 0.4695L3.35849 2.8306L0.729592 3.2803C0.407092 3.3355 0.144142 3.563 0.0430919 3.87405C-0.0577581 4.1851 0.0213419 4.5237 0.249642 4.75785L2.11219 6.66655L1.72719 9.3057C1.68009 9.62945 1.81509 9.95025 2.07999 10.1422C2.23309 10.2535 2.41324 10.3101 2.59489 10.3101C2.72744 10.3101 2.86049 10.2799 2.98429 10.2188L5.37489 9.03715L7.76549 10.2183C8.05944 10.3638 8.40514 10.335 8.66979 10.1422C8.93444 9.94975 9.06969 9.62945 9.02234 9.3057L8.63804 6.66655L10.5003 4.7576C10.7288 4.5232 10.8079 4.1843 10.7064 3.87305ZM9.96324 4.2339L7.97154 6.2754C7.88999 6.3589 7.85239 6.4756 7.86899 6.5913L8.28014 9.41405C8.28989 9.48045 8.25229 9.51855 8.22934 9.53515C8.20589 9.55275 8.15804 9.57665 8.09799 9.5459L5.54084 8.28225C5.43634 8.2305 5.31354 8.23145 5.20854 8.28225L2.65164 9.5464C2.59159 9.5752 2.54349 9.55225 2.52054 9.53515C2.49709 9.51855 2.45949 9.47995 2.46929 9.41405L2.88089 6.5913C2.89774 6.4756 2.85964 6.3589 2.77809 6.2754L0.786142 4.2339C0.739492 4.1863 0.747592 4.13305 0.756342 4.10575C0.765392 4.0784 0.790042 4.0308 0.855942 4.01955L3.66744 3.5386C3.78269 3.5188 3.88204 3.4468 3.93624 3.3433L5.26219 0.8179C5.29319 0.7588 5.34594 0.75005 5.37474 0.75005C5.40354 0.75005 5.45629 0.75885 5.48729 0.8179L6.81324 3.3433C6.86744 3.4468 6.96704 3.51885 7.08179 3.5386L9.89379 4.01955C9.95969 4.0308 9.98414 4.07815 9.99339 4.1055C10.0022 4.13285 10.0101 4.18605 9.96324 4.2339Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

StarEmptyIcon.displayName = 'StarEmptyIcon';
